import {TextContainer} from "../components/TextContainer";

export const ErrorPage= () => {
    return (
        <TextContainer>
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
        </TextContainer>
    );
}
